// extracted by mini-css-extract-plugin
export default {"root":"ChallengeLength_root__tpLzn"};